import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { FileText, LogIn, Users, Settings } from 'lucide-react';
import { Logo } from '@atoms';
import { UserMenu } from '@molecules/UserMenu';
import { useAuth } from '@contexts/AuthContext';

export const Header: React.FC = () => {
  const location = useLocation();
  const { user, isAuthenticated } = useAuth();

  const isActive = (path: string) => {
    return location.pathname === path;
  };

  // Check if user has admin privileges
  const isAdmin = user?.isAdmin || user?.roles?.some(role => role.name === 'admin') || false;

  return (
    <header className="bg-primary-500 shadow-lg">
      <div className="container mx-auto px-4">
        <div className="flex items-center justify-between h-16">
          {/* Logo on the left */}
          <Link to="/" className="hover:opacity-80 transition-opacity">
            <Logo size="md" />
          </Link>
          
          {/* Navigation on the right */}
          <nav className="flex items-center space-x-1">
            {isAuthenticated ? (
              <>
                <Link
                  to="/invoices"
                  className={`flex items-center space-x-2 px-4 py-2 rounded-lg text-sm font-medium transition-all duration-200 ${
                    isActive('/invoices')
                      ? 'text-primary-600 bg-white shadow-md'
                      : 'text-white hover:text-accent-200 hover:bg-primary-600'
                  }`}
                >
                  <FileText className="w-4 h-4" />
                  <span>Invoices</span>
                </Link>
                
                <Link
                  to="/suppliers"
                  className={`flex items-center space-x-2 px-4 py-2 rounded-lg text-sm font-medium transition-all duration-200 ${
                    isActive('/suppliers')
                      ? 'text-primary-600 bg-white shadow-md'
                      : 'text-white hover:text-accent-200 hover:bg-primary-600'
                  }`}
                >
                  <Users className="w-4 h-4" />
                  <span>Suppliers</span>
                </Link>
                
                {/* Admin navigation - only show to admin users */}
                {isAdmin && (
                  <Link
                    to="/admin"
                    className={`flex items-center space-x-2 px-4 py-2 rounded-lg text-sm font-medium transition-all duration-200 ${
                      isActive('/admin')
                        ? 'text-primary-600 bg-white shadow-md'
                        : 'text-white hover:text-accent-200 hover:bg-primary-600'
                    }`}
                  >
                    <Settings className="w-4 h-4" />
                    <span>Admin</span>
                  </Link>
                )}

                {/* User Menu */}
                <UserMenu />
              </>
            ) : (
              <Link
                to="/auth"
                className={`flex items-center space-x-2 px-4 py-2 rounded-lg text-sm font-medium transition-all duration-200 ${
                  isActive('/auth')
                    ? 'text-primary-600 bg-white shadow-md'
                    : 'text-white hover:text-accent-200 hover:bg-primary-600'
                }`}
              >
                <LogIn className="w-4 h-4" />
                <span>Login</span>
              </Link>
            )}
          </nav>
        </div>
      </div>
    </header>
  );
}; 